import "D:\\FOTA\\FOTAWeb\\FOTAmanager\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\FOTA\\FOTAWeb\\FOTAmanager\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\FOTA\\FOTAWeb\\FOTAmanager\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\FOTA\\FOTAWeb\\FOTAmanager\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from 'vue';
import router from "./router";
import ElementUI from 'element-ui';
import _i18n from "./resources/index";
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题

import App from "./App.vue";
import "./assets/css/icon.css";
import 'babel-polyfill';
import axios from 'axios'; //import elTableTransfer from 'el-table-transfer';

import echarts from 'echarts';
import api from "./api/api";
import global from "./components/common/global"; //Vue.use(elTableTransfer);

Vue.prototype.axios = axios;
Vue.prototype.GLOBAL = App; //全局变量

Vue.prototype.global = global;
Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
import XLSX from 'xlsx';
Vue.use(XLSX);
Vue.use(ElementUI, {
  size: 'small',
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
}); // Vue.prototype.$http = axios;
//使用钩子函数对路由进行权限跳转

router.beforeEach(function (to, from, next) {
  // document.title = `${to.meta.title} | FOTA Manager`;
  var role = localStorage.getItem('account');

  if (!role && to.path !== '/login') {
    next('/login');
  } else if (to.meta.permission) {
    role === 'admin' ? next() : next('/403');
  } else {
    next();
  }
});
new Vue({
  router: router,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app');